module.exports = __webpack_public_path__ + "static/img/yunqi_logo11.85f7f811.png";